import { render, staticRenderFns } from "./ShipmentOverview.vue?vue&type=template&id=004063ad&scoped=true&"
import script from "./ShipmentOverview.vue?vue&type=script&lang=js&"
export * from "./ShipmentOverview.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentOverview.vue?vue&type=style&index=0&id=004063ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004063ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004063ad')) {
      api.createRecord('004063ad', component.options)
    } else {
      api.reload('004063ad', component.options)
    }
    module.hot.accept("./ShipmentOverview.vue?vue&type=template&id=004063ad&scoped=true&", function () {
      api.rerender('004063ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/ShipmentOverview.vue"
export default component.exports